import { useParams } from 'react-router-dom'

export const useProductIdParam = () => {
  const params: any = useParams()

  if (!params?._id) {
    return undefined
  }

  return decodeURIComponent(params?._id)
}
